module.exports = __webpack_public_path__ + "static/img/activity03.fd1e6dee.png";